import type { FaireProductEntity } from "../../entity_types/product";

export const p_pp76akzhdp: FaireProductEntity = {
  token: "p_pp76akzhdp",
  type: "product",
  name: "Vase, Oat Milk",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/0912fbb28635b989b8adc9b228f26d1bc5bd59e37e7fcae501bfdd1fd010a736.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03ba3f78f4230a7fe872c96d203e37fc16651598fe7ec9b55bf4a48f795c4efb.jpeg",
    "https://cdn.faire.com/fastly/de12bedccf26b11e648707b64faf8f7c3a1401975bdac15c1b3c3ce3ed9c536f.jpeg"
  ],
  priceDollars: 14,
  description: "Oat milk—what can’t it do?! This porcelain vase adds a splash of charm to any table or shelf in your home. Cute, quirky, and totally display-worthy, it’s perfect for fresh flowers, dried stems, or standing solo as a conversation-starting décor piece.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Porcelain vase inspired by oat milk packaging\n• Perfect for flowers, dried stems, or decorative styling\n• Adds a fun, modern twist to shelves, desks, and tables\n• Durable and easy to style in any room\n• Designed in Bando’s signature bright and whimsical style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and home décor boutiques\n• Lifestyle and kitchenware retailers\n• Home decorators, design lovers, and collectors of novelty ceramics\n• Wholesale buyers seeking cute, statement home accessories",
  tags: [],
  msrpDollars: 28.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:18.312Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
